export default __webpack_public_path__ + "static/media/livingthunderstorm.512b6726.png";